// ============================================
// 📱 APP: NVA (React App)
// 📄 FILE: src/pages/services/useServiceBack.ts
// 🔧 PURPOSE: Il "‹" delle pagine dei servizi, come nella Fuga romantica
//             (pages/RomanticEscape): aperta da dentro l'app, la pagina
//             torna indietro di un passo (di solito la Home, che ritrova il
//             suo posto); aperta da un link diretto (notifica, messaggio,
//             nuova scheda), senza niente prima, va a `fallback` (la Home)
//             sostituendo la voce, così il tasto indietro del telefono non
//             ci riporta qui.
// ============================================

import { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

/**
 * C'è una voce dell'app prima di questa? Con BrowserRouter lo dice l'indice
 * che react-router scrive in history.state (0 = la prima voce dell'app);
 * senza (MemoryRouter, i test) la chiave della voce: "default" è la prima.
 */
function hasAppEntryBefore(locationKey: string): boolean {
  const state = typeof window !== 'undefined' ? window.history.state : null;
  if (state && typeof state.idx === 'number') return state.idx > 0;
  return locationKey !== 'default';
}

/** Il "‹": indietro di un passo se si viene dall'app, altrimenti `fallback` (sostituendo la voce). */
export function useServiceBack(fallback: string = '/'): () => void {
  const navigate = useNavigate();
  const { key } = useLocation();
  return useCallback(() => {
    if (hasAppEntryBefore(key)) navigate(-1);
    else navigate(fallback, { replace: true });
  }, [navigate, key, fallback]);
}

export default useServiceBack;
